import { CONTEXT_PARAMS, URL_PARAMS } from '../../config/enrichlyParams';

export function parseUrlContext(search: string): Record<string, string> {
  const params = new URLSearchParams(search);
  const partial: Record<string, string> = {};

  URL_PARAMS.forEach(p => {
    const v = params.get(p.urlKey);
    if (v && (!p.validate || p.validate(v))) {
      partial[p.contextKey] = v;
    }
  });

  CONTEXT_PARAMS.forEach(p => {
    if (p.urlFallbackKey) {
      const v = params.get(p.urlFallbackKey);
      if (v && (!p.validate || p.validate(v))) {
        partial[p.contextKey] = v;
      }
    }
  });

  return partial;
}
